// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__e-mnn","top":"styles_top__3v0Hj"};